import { Box, Button, ButtonGroup, TextButton } from '@zillow/constellation-10';
import { IconArrowRightOutline } from '@zillow/constellation-icons';

import { LoadingParagraph } from '@zg-rentals/loading-components';

import ClaimListingCard from '../ClaimListingCard';
import WizardBodyTemplate from '../WizardBodyTemplate';
import WizardStepController from '../WizardStepController';
import { PROGRESS_STEP, PROGRESS_STEP_CONFIG, STEP } from './constants';
import { SKELETON_LISTING } from './WizFindListingResults';

import type { WizardBodyTemplateProps } from '../WizardStepController';

const SKELETON_CARD_KEYS = ['skeleton-0', 'skeleton-1', 'skeleton-2', 'skeleton-3', 'skeleton-4'];

function ListingClaimingSkeletonBody({ progressStepper }: WizardBodyTemplateProps) {
  return (
    <WizardBodyTemplate
      title="Your listings"
      mobileTitle="Listing results"
      icon={null}
      progressStepper={progressStepper}
      subtitle={
        <LoadingParagraph isLoading loadingWidth="100%">
          &nbsp;
        </LoadingParagraph>
      }
      footer={
        <ButtonGroup aria-label="Find listing results" orientation="vertical">
          <TextButton disabled>Search for more listings</TextButton>
          <Button tone="brand" emphasis="filled" disabled icon={<IconArrowRightOutline />}>
            Next
          </Button>
        </ButtonGroup>
      }
    >
      <Box
        css={{
          borderBlock: '1px solid {colors.border.subtle}',
          md: { overflowY: 'auto', maxHeight: '940px' },
        }}
      >
        {SKELETON_CARD_KEYS.map((key) => (
          <ClaimListingCard key={key} listingData={SKELETON_LISTING} loading />
        ))}
      </Box>
    </WizardBodyTemplate>
  );
}

const SKELETON_STEP = {
  stepKey: STEP.FIND_LISTING_RESULTS,
  wizardBodyTemplate: ListingClaimingSkeletonBody,
  progressStepKey: PROGRESS_STEP.FIND_LISTING,
};

export default function ListingClaimingSkeleton() {
  return (
    <Box css={{ backgroundColor: 'bg.softer' }}>
      <WizardStepController
        steps={[SKELETON_STEP]}
        progressSteps={PROGRESS_STEP_CONFIG}
        currentStepKey={STEP.FIND_LISTING_RESULTS}
        onGoToStep={() => {}}
      />
    </Box>
  );
}
